import type { FaireProductEntity } from "../../entity_types/product";

export const p_kthk92ruvt: FaireProductEntity = {
  token: "p_kthk92ruvt",
  type: "product",
  name: "The Beekeeper - Honey + Clover - 8oz Glass Candle",
  brandToken: "b_sec844xbdh",
  brandName: "Field Kit",
  imageUrl:
    "https://cdn.faire.com/fastly/bb4837b80dd3ddc2722f8fc3480741898fa6eef4322a664260da71eab0c3cb52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b89f6bc2f834878d2101772c0d589373c1b70148535fa6c5fc705dafca864fc2.jpeg",
    "https://cdn.faire.com/fastly/c6df0c4c0c01addfb157a0137152c617dcb3deca9a6cd377a87d92a4e452253a.jpeg",
    "https://cdn.faire.com/fastly/dcb43e7d42d8cc743c6cc465c07282d201066d431daecb63a01892a789abb4bd.jpeg",
  ],
  priceDollars: 18.5,
  description:
    "Clouds of honey bees\nGolden light\nA sea of swaying grass\n\nTop notes - sweet orange + apple\nMid notes - clover + wild honey\nBase notes - white musk\n\nIngredients\n100% soy wax\nClean burning cotton wick\nFine fragrance oils\nReusable glass jar\n\nSize\n8oz | 227g\n50+ hour burn time",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:11.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
